import React, { useState } from 'react';
import { Dialog, DialogContent } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { useToast } from '../hooks/use-toast';
import { Loader2, Shield } from 'lucide-react';

const countryCodes = [
  { code: '+1', flag: '\u{1F1FA}\u{1F1F8}', name: 'US' },
  { code: '+1', flag: '\u{1F1E8}\u{1F1E6}', name: 'CA' },
  { code: '+44', flag: '\u{1F1EC}\u{1F1E7}', name: 'UK' },
  { code: '+91', flag: '\u{1F1EE}\u{1F1F3}', name: 'IN' },
  { code: '+86', flag: '\u{1F1E8}\u{1F1F3}', name: 'CN' },
  { code: '+81', flag: '\u{1F1EF}\u{1F1F5}', name: 'JP' },
  { code: '+82', flag: '\u{1F1F0}\u{1F1F7}', name: 'KR' },
  { code: '+49', flag: '\u{1F1E9}\u{1F1EA}', name: 'DE' },
  { code: '+33', flag: '\u{1F1EB}\u{1F1F7}', name: 'FR' },
  { code: '+39', flag: '\u{1F1EE}\u{1F1F9}', name: 'IT' },
  { code: '+34', flag: '\u{1F1EA}\u{1F1F8}', name: 'ES' },
  { code: '+31', flag: '\u{1F1F3}\u{1F1F1}', name: 'NL' },
  { code: '+46', flag: '\u{1F1F8}\u{1F1EA}', name: 'SE' },
  { code: '+47', flag: '\u{1F1F3}\u{1F1F4}', name: 'NO' },
  { code: '+45', flag: '\u{1F1E9}\u{1F1F0}', name: 'DK' },
  { code: '+41', flag: '\u{1F1E8}\u{1F1ED}', name: 'CH' },
  { code: '+43', flag: '\u{1F1E6}\u{1F1F9}', name: 'AT' },
  { code: '+48', flag: '\u{1F1F5}\u{1F1F1}', name: 'PL' },
  { code: '+351', flag: '\u{1F1F5}\u{1F1F9}', name: 'PT' },
  { code: '+353', flag: '\u{1F1EE}\u{1F1EA}', name: 'IE' },
  { code: '+32', flag: '\u{1F1E7}\u{1F1EA}', name: 'BE' },
  { code: '+358', flag: '\u{1F1EB}\u{1F1EE}', name: 'FI' },
  { code: '+7', flag: '\u{1F1F7}\u{1F1FA}', name: 'RU' },
  { code: '+380', flag: '\u{1F1FA}\u{1F1E6}', name: 'UA' },
  { code: '+90', flag: '\u{1F1F9}\u{1F1F7}', name: 'TR' },
  { code: '+30', flag: '\u{1F1EC}\u{1F1F7}', name: 'GR' },
  { code: '+40', flag: '\u{1F1F7}\u{1F1F4}', name: 'RO' },
  { code: '+36', flag: '\u{1F1ED}\u{1F1FA}', name: 'HU' },
  { code: '+420', flag: '\u{1F1E8}\u{1F1FF}', name: 'CZ' },
  { code: '+61', flag: '\u{1F1E6}\u{1F1FA}', name: 'AU' },
  { code: '+64', flag: '\u{1F1F3}\u{1F1FF}', name: 'NZ' },
  { code: '+55', flag: '\u{1F1E7}\u{1F1F7}', name: 'BR' },
  { code: '+52', flag: '\u{1F1F2}\u{1F1FD}', name: 'MX' },
  { code: '+54', flag: '\u{1F1E6}\u{1F1F7}', name: 'AR' },
  { code: '+56', flag: '\u{1F1E8}\u{1F1F1}', name: 'CL' },
  { code: '+57', flag: '\u{1F1E8}\u{1F1F4}', name: 'CO' },
  { code: '+51', flag: '\u{1F1F5}\u{1F1EA}', name: 'PE' },
  { code: '+971', flag: '\u{1F1E6}\u{1F1EA}', name: 'AE' },
  { code: '+966', flag: '\u{1F1F8}\u{1F1E6}', name: 'SA' },
  { code: '+974', flag: '\u{1F1F6}\u{1F1E6}', name: 'QA' },
  { code: '+973', flag: '\u{1F1E7}\u{1F1ED}', name: 'BH' },
  { code: '+968', flag: '\u{1F1F4}\u{1F1F2}', name: 'OM' },
  { code: '+965', flag: '\u{1F1F0}\u{1F1FC}', name: 'KW' },
  { code: '+962', flag: '\u{1F1EF}\u{1F1F4}', name: 'JO' },
  { code: '+961', flag: '\u{1F1F1}\u{1F1E7}', name: 'LB' },
  { code: '+972', flag: '\u{1F1EE}\u{1F1F1}', name: 'IL' },
  { code: '+20', flag: '\u{1F1EA}\u{1F1EC}', name: 'EG' },
  { code: '+27', flag: '\u{1F1FF}\u{1F1E6}', name: 'ZA' },
  { code: '+234', flag: '\u{1F1F3}\u{1F1EC}', name: 'NG' },
  { code: '+254', flag: '\u{1F1F0}\u{1F1EA}', name: 'KE' },
  { code: '+255', flag: '\u{1F1F9}\u{1F1FF}', name: 'TZ' },
  { code: '+233', flag: '\u{1F1EC}\u{1F1ED}', name: 'GH' },
  { code: '+212', flag: '\u{1F1F2}\u{1F1E6}', name: 'MA' },
  { code: '+65', flag: '\u{1F1F8}\u{1F1EC}', name: 'SG' },
  { code: '+60', flag: '\u{1F1F2}\u{1F1FE}', name: 'MY' },
  { code: '+66', flag: '\u{1F1F9}\u{1F1ED}', name: 'TH' },
  { code: '+84', flag: '\u{1F1FB}\u{1F1F3}', name: 'VN' },
  { code: '+63', flag: '\u{1F1F5}\u{1F1ED}', name: 'PH' },
  { code: '+62', flag: '\u{1F1EE}\u{1F1E9}', name: 'ID' },
  { code: '+880', flag: '\u{1F1E7}\u{1F1E9}', name: 'BD' },
  { code: '+92', flag: '\u{1F1F5}\u{1F1F0}', name: 'PK' },
  { code: '+94', flag: '\u{1F1F1}\u{1F1F0}', name: 'LK' },
  { code: '+977', flag: '\u{1F1F3}\u{1F1F5}', name: 'NP' },
  { code: '+852', flag: '\u{1F1ED}\u{1F1F0}', name: 'HK' },
  { code: '+886', flag: '\u{1F1F9}\u{1F1FC}', name: 'TW' },
];

const ContactFormDialog = ({ isOpen, onClose }) => {
  const { toast } = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', countryCode: '+1-US', phone: '', description: '' });
  const [errors, setErrors] = useState({ email: '', phone: '' });

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handlePhoneChange = (value) => {
    const digits = value.replace(/\D/g, '');
    if (digits.length <= 10) {
      setFormData((p) => ({ ...p, phone: digits }));
      setErrors((p) => ({ ...p, phone: digits && digits.length !== 10 ? 'Must be 10 digits' : '' }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = { email: '', phone: '' };
    let hasErrors = false;
    if (!validateEmail(formData.email)) { newErrors.email = 'Enter a valid email'; hasErrors = true; }
    if (formData.phone.length !== 10) { newErrors.phone = 'Must be 10 digits'; hasErrors = true; }
    if (hasErrors) { setErrors(newErrors); return; }
    setIsSubmitting(true);
    setTimeout(() => {
      toast({ title: "Request Submitted!", description: "Our team will reach out within 24 hours." });
      setIsSubmitting(false);
      setFormData({ name: '', email: '', countryCode: '+1-US', phone: '', description: '' });
      setErrors({ email: '', phone: '' });
      onClose();
    }, 1500);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent data-testid="contact-form-dialog" className="max-w-[780px] p-0 gap-0 overflow-hidden bg-wine-900 border-wine-700/50">
        <div className="flex">
          {/* Left - Image */}
          <div className="hidden md:block w-[300px] flex-shrink-0 relative">
            <img src="https://images.unsplash.com/photo-1589330694653-ded6df03f754?w=600&h=900&fit=crop" alt="Legal trademark documents" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-wine-950/90 via-wine-950/40 to-wine-950/20" />
            <div className="absolute bottom-6 left-6 right-6">
              <div className="bg-gradient-to-r from-gold-500 to-gold-400 text-wine-950 text-xs font-bold px-3 py-1 rounded-full inline-block mb-3">Starting at $45</div>
              <h3 className="text-white font-bold text-lg leading-tight">Protect Your Brand with Federal Trademark Registration</h3>
              <p className="text-wine-300 text-xs mt-2">USPTO filing by licensed attorneys</p>
            </div>
          </div>

          {/* Right - Form */}
          <div className="flex-1 min-w-0">
            <div className="bg-wine-800 px-5 py-4 border-b border-wine-700/30">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 bg-wine-600 rounded-lg flex items-center justify-center">
                  <Shield className="w-4 h-4 text-white" />
                </div>
                <div>
                  <h2 className="text-base font-bold text-white leading-tight">Trademark Text Logo</h2>
                  <p className="text-wine-400 text-xs">Expert trademark registration services</p>
                </div>
              </div>
            </div>

            <div className="px-5 py-4">
              <h3 className="text-base font-bold text-white mb-0.5">Start Your Registration</h3>
              <p className="text-xs text-wine-400 mb-3">Fill in your details and our experts will guide you.</p>

              <form onSubmit={handleSubmit} className="space-y-2.5">
                <div className="space-y-1">
                  <Label className="text-xs font-medium text-wine-200">Name *</Label>
                  <Input data-testid="dialog-name-input" placeholder="Full name" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required className="h-9 text-sm bg-wine-800/50 border-wine-700/50 text-white placeholder:text-wine-500 focus:border-gold-500" />
                </div>
                <div className="space-y-1">
                  <Label className="text-xs font-medium text-wine-200">Email *</Label>
                  <Input data-testid="dialog-email-input" type="email" placeholder="you@company.com" value={formData.email} onChange={(e) => { setFormData({ ...formData, email: e.target.value }); setErrors((p) => ({ ...p, email: '' })); }} required className={`h-9 text-sm bg-wine-800/50 ${errors.email ? 'border-red-400' : 'border-wine-700/50'} text-white placeholder:text-wine-500 focus:border-gold-500`} />
                  {errors.email && <p className="text-red-400 text-xs">{errors.email}</p>}
                </div>
                <div className="space-y-1">
                  <Label className="text-xs font-medium text-wine-200">Contact Number *</Label>
                  <div className="flex gap-2">
                    <Select value={formData.countryCode} onValueChange={(v) => setFormData({ ...formData, countryCode: v })}>
                      <SelectTrigger data-testid="dialog-country-code" className="w-[110px] h-9 text-sm bg-wine-800/50 border-wine-700/50 text-white"><SelectValue /></SelectTrigger>
                      <SelectContent className="bg-wine-900 border-wine-700 text-white max-h-[250px] overflow-y-auto">
                        {countryCodes.map((c) => (
                          <SelectItem key={`${c.code}-${c.name}`} value={`${c.code}-${c.name}`} className="hover:bg-wine-800 focus:bg-wine-800 focus:text-white">
                            <span className="flex items-center gap-1.5"><span>{c.flag}</span> {c.code} {c.name}</span>
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                    <Input data-testid="dialog-phone-input" type="tel" placeholder="1234567890" value={formData.phone} onChange={(e) => handlePhoneChange(e.target.value)} required maxLength={10} className={`flex-1 h-9 text-sm bg-wine-800/50 ${errors.phone ? 'border-red-400' : 'border-wine-700/50'} text-white placeholder:text-wine-500 focus:border-gold-500`} />
                  </div>
                  {errors.phone && <p className="text-red-400 text-xs">{errors.phone}</p>}
                </div>
                <div className="space-y-1">
                  <Label className="text-xs font-medium text-wine-200">Description</Label>
                  <Textarea data-testid="dialog-description-input" placeholder="What are you looking to protect?" rows={2} value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} className="text-sm bg-wine-800/50 border-wine-700/50 text-white placeholder:text-wine-500 focus:border-gold-500 resize-none" />
                </div>
                <Button data-testid="dialog-submit-btn" type="submit" className="w-full bg-gradient-to-r from-wine-600 to-wine-500 hover:from-wine-500 hover:to-wine-400 text-white h-9 text-sm font-semibold shadow-lg" disabled={isSubmitting}>
                  {isSubmitting ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Submitting...</> : 'Register My Trademark Now'}
                </Button>
                <p className="text-xs text-wine-500 text-center">By submitting, you agree to our Terms and Privacy Policy.</p>
              </form>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ContactFormDialog;
